
import { Vue } from "vue-class-component";

export default class Attachment extends Vue {}
